<template>
  <v-row justify="center" style="flex: initial">
    <v-dialog
      v-model="$store.state.confirmDialog.view.isConfirmDialogShown"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline d-block text-center">{{
          $store.state.confirmDialog.mainData.title
        }}</v-card-title>
        <v-card-text class="d-block text-center">{{
          $store.state.confirmDialog.mainData.text
        }}</v-card-text>
        <v-card-actions class="d-flex justify-center">
          <v-btn
            v-if="$store.state.confirmDialog.mainData.button2"
            color="primary darken-1"
            text
            @click="
              $store.commit('changeConfirmDialogView', {
                isShown: false,
              })
            "
            >{{ $store.state.confirmDialog.mainData.button2 }}</v-btn
          >
          <!-- <div class="flex-grow-1"></div> -->
          <v-btn
            v-if="$store.state.confirmDialog.mainData.button1"
            color="error darken-1"
            text
            @click="
              $store.commit('changeConfirmDialogView', {
                isShown: false,
                type: '',
              })
            "
            >{{ $store.state.confirmDialog.mainData.button1 }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'AppConfirmDialog',
}
</script>

<style lang="scss" scoped></style>
